import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=679ea164&scoped=true&lang=pug&"
import script from "./Spinner.vue?vue&type=script&lang=js&"
export * from "./Spinner.vue?vue&type=script&lang=js&"
import style0 from "./Spinner.vue?vue&type=style&index=0&id=679ea164&lang=sass&nolang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679ea164",
  null
  
)

export default component.exports